import AOS from 'aos';
import 'aos/dist/aos.css';
import React, { useState, useEffect, useRef, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaComments, FaWhatsapp, FaFilter, FaTimes, FaPhone } from 'react-icons/fa';
import ProductCard from './ProductCard';
import OfferSection from './OfferSection';
import ChatScreen from './ChatScreen';
import FeaturesSection from './FeaturesSection';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookMessenger } from '@fortawesome/free-brands-svg-icons';
import ProductFeaturesSection from './ProductFeaturesSection';
import SocialMediaSection from './SocialMediaSection';

const ProductList = ({
  products,
  addToCart,
  toggleFavorite,
  isFavorite,
  cartItems,
  currentPage,
  totalPages,
  onPageChange,
}) => {
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [priceRange, setPriceRange] = useState([0, 200000]);
  const [minPrice, setMinPrice] = useState(0);
  const [maxPrice, setMaxPrice] = useState(200000);
  const [searchQuery, setSearchQuery] = useState('');
  const [sortOption, setSortOption] = useState('');
  const [selectedMainCategory, setSelectedMainCategory] = useState('');
  const [selectedSubCategory, setSelectedSubCategory] = useState('');
  const [currentSlide, setCurrentSlide] = useState(0);
  const [carouselImages, setCarouselImages] = useState([]);
  const [isChatPopupOpen, setIsChatPopupOpen] = useState(false);
  const [showButtonText, setShowButtonText] = useState(true);
  const [isOptionsMenuOpen, setIsOptionsMenuOpen] = useState(false);
  const [isMobileFilterOpen, setIsMobileFilterOpen] = useState(false);
  const [cardBanners, setCardBanners] = useState([]);
  const [adBanner, setAdBanner] = useState(null);
  const [upcomingCampaigns, setUpcomingCampaigns] = useState([]);

  const [apiCategories, setApiCategories] = useState([]);
  const defaultCategories = ['Gadget', 'Toys', 'Home Accessories', 'PC Component', "Gym", "Smart Watch", "Light"];


  const navigate = useNavigate();

  const whatsAppPhoneNumber = '8801345688562';
  const whatsAppDefaultMessage = 'Hello! I visited your website and would like some information.';

  // AOS initialization
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });
  }, []);



  const handleMessengerClick = () => {
    window.open('https://m.me/elevateemart', '_blank');
    setIsOptionsMenuOpen(false);
  };

  const handleCallClick = () => {
    window.location.href = 'tel:+8809647001250';
    setIsOptionsMenuOpen(false);
  };





  const handleApplyFilters = () => {
    // Apply all filters
    if (isMobileFilterOpen) {
      setIsMobileFilterOpen(false);
    }
    // Filter logic will automatically work through useMemo
  };

  const handleClearFilters = () => {
    setSelectedCategories([]);
    setPriceRange([0, 200000]);
    setMinPrice(0);
    setMaxPrice(200000);
    setSearchQuery('');
    setSortOption('');
    setSelectedMainCategory('');
    setSelectedSubCategory('');
  };


  // Fetch carousel images
  useEffect(() => {
    const fetchCarouselImages = async () => {
      try {
        const response = await fetch('https://bazar-wala-main-server-974485829900.asia-south1.run.app/active_images');
        const data = await response.json();
        if (data.status === 'success') {
          setCarouselImages(data.images);
        } else {
          console.error('Error fetching carousel images:', data.message);
          setCarouselImages([
            'https://via.placeholder.com/800x300/33FF57/FFFFFF?text=Slide+1',
            'https://via.placeholder.com/800x300/3357FF/FFFFFF?text=Slide+2',
            'https://via.placeholder.com/800x300/FF33CC/FFFFFF?text=Slide+3',
          ]);
        }
      } catch (error) {
        console.error('Network error fetching carousel images:', error);
        setCarouselImages([
          'https://via.placeholder.com/800x300/33FF57/FFFFFF?text=Slide+1',
          'https://via.placeholder.com/800x300/3357FF/FFFFFF?text=Slide+2',
          'https://via.placeholder.com/800x300/FF33CC/FFFFFF?text=Slide+3',
        ]);
      }
    };

    fetchCarouselImages();
  }, []);

  const goToNextSlide = () => {
    setCurrentSlide((prevSlide) =>
      prevSlide === carouselImages.length - 1 ? 0 : prevSlide + 1
    );
  };



  useEffect(() => {
    const fetchUpcomingCampaigns = async () => {
      try {
        const response = await fetch('https://bazar-wala-main-server-974485829900.asia-south1.run.app/api/campaigns');
        const data = await response.json();
        if (data.success) {
          setUpcomingCampaigns(data.data);
        }
      } catch (error) {
        console.error('Error fetching upcoming campaigns:', error);
      }
    };

    fetchUpcomingCampaigns();
  }, []);

  // Helper function to calculate time remaining
  const getTimeRemaining = (endDateTime) => {
    const now = new Date();
    const end = new Date(endDateTime);
    const difference = end - now;

    if (difference <= 0) {
      return { days: 0, hours: 0, minutes: 0, seconds: 0 };
    }

    return {
      days: Math.floor(difference / (1000 * 60 * 60 * 24)),
      hours: Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
      minutes: Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60)),
      seconds: Math.floor((difference % (1000 * 60)) / 1000)
    };
  };

const CampaignCard = ({ campaign }) => {
  const [timeRemaining, setTimeRemaining] = useState(getTimeRemaining(campaign.endDateTime));

  useEffect(() => {
    const interval = setInterval(() => {
      setTimeRemaining(getTimeRemaining(campaign.endDateTime));
    }, 1000);

    return () => clearInterval(interval);
  }, [campaign.endDateTime]);

const timerBoxStyle = {
  background: "linear-gradient(145deg, #1a1b1f 0%, #25262b 100%)",
  border: "1px solid #F88702",
  clipPath: "polygon(6px 0%, calc(100% - 6px) 0%, 100% 50%, calc(100% - 6px) 100%, 6px 100%, 0% 50%)",
  fontFamily: "'Półtawski Nowy', serif",
};

const timerBoxStyleLg = {
  background: "linear-gradient(145deg, #1a1b1f 0%, #25262b 100%)",
  border: "1px solid #F88702",
  clipPath: "polygon(8px 0%, calc(100% - 8px) 0%, 100% 50%, calc(100% - 8px) 100%, 8px 100%, 0% 50%)",
  fontFamily: "'Półtawski Nowy', serif",
};

  return (
    <div
      className="h-full w-full p-1.5 md:p-4"
      style={{
        background: "linear-gradient(135deg, #fff 60%, #F5D19D33 100%)",
        borderTop: "3px solid #CD0302",
        boxShadow: "3px 3px 0px #4F7E17",
      }}
    >
      {/* Mobile Layout - Horizontal */}
      <div className="md:hidden flex gap-1.5 h-full">
        {/* Left Side - Image & Title */}
        <div className="flex-shrink-0 w-[100px] flex flex-col justify-center">
          <div className="w-full mb-0.5">
            <img
              src={campaign.imageUrl}
              alt={campaign.title}
              className="w-full h-auto object-contain mx-auto max-h-[35px]"
            />
          </div>
          <p
            className="text-[8px] font-semibold text-center line-clamp-2 mb-0.5 leading-tight"
            style={{ fontFamily: "'Półtawski Nowy', serif", color: "#1a1b1f" }}
          >
            {campaign.title}
          </p>
          <p
            className="text-[7px] font-medium text-center leading-tight"
            style={{ fontFamily: "'Półtawski Nowy', serif", color: "#F88702" }}
          >
            Campaign starts in
          </p>
        </div>

        {/* Right Side - Timer (2x2 Grid) */}
        <div className="flex-1 flex items-center">
          <div className="grid grid-cols-2 gap-1 w-full">
            {[
              { val: timeRemaining.days, label: "days" },
              { val: timeRemaining.hours, label: "hrs" },
              { val: timeRemaining.minutes, label: "min" },
              { val: timeRemaining.seconds, label: "sec" },
            ].map(({ val, label }) => (
              <div key={label} style={timerBoxStyle} className="px-1 py-1.5 text-center">
                <p className="text-[10px] font-bold text-white leading-none">{val}</p>
                <p className="text-[6.5px] leading-none mt-0.5" style={{ color: "#F0C400" }}>
                  {label}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Desktop Layout - Vertical */}
      <div className="hidden md:flex flex-col gap-2 h-full">
        <div className="flex-1">
          <div className="w-full mb-2">
            <img
              src={campaign.imageUrl}
              alt={campaign.title}
              className="w-full h-auto object-contain mx-auto max-h-[80px]"
            />
          </div>
          <p
            className="mb-1 text-sm font-semibold text-center line-clamp-1"
            style={{ fontFamily: "'Półtawski Nowy', serif", color: "#1a1b1f" }}
          >
            {campaign.title}
          </p>
          <p
            className="mb-1 text-xs font-medium text-center"
            style={{ fontFamily: "'Półtawski Nowy', serif", color: "#F88702" }}
          >
            Campaign starts in
          </p>
        </div>
        <div className="flex-1">
          <div className="items-center gap-2 grid grid-cols-2">
            {[
              { val: timeRemaining.days, label: "d" },
              { val: timeRemaining.hours, label: "h" },
              { val: timeRemaining.minutes, label: "m" },
              { val: timeRemaining.seconds, label: "s" },
            ].map(({ val, label }) => (
              <div
                key={label}
                style={timerBoxStyleLg}
                className="w-full py-1.5 lg:py-2 h-full px-1 text-center"
              >
                <span
                  className="text-base lg:text-lg font-bold text-white"
                  style={{ fontFamily: "'Półtawski Nowy', serif" }}
                >
                  {val}{label}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};





  // Fetch card banners and ad banner
  useEffect(() => {
    const fetchBanners = async () => {
      try {
        const response = await fetch('https://bazar-wala-main-server-974485829900.asia-south1.run.app/api/home-card-banners');
        const data = await response.json();

        if (data.success) {
          setCardBanners(data.data.cardBanners || []);
          setAdBanner(data.data.adBanner);
        } else {
          console.error('Error fetching banners:', data.error);
        }
      } catch (error) {
        console.error('Network error fetching banners:', error);
      }
    };

    fetchBanners();
  }, []);



  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await fetch('https://bazar-wala-main-server-974485829900.asia-south1.run.app/api/categories');
        const data = await response.json();
        if (data.success && data.categories && data.categories.length > 0) {
          const activeCategories = data.categories
            .filter(cat => cat.isActive)
            .map(cat => cat.name);
          setApiCategories(activeCategories);
        }
      } catch (error) {
        console.error('Failed to fetch categories:', error);
      }
    };
    fetchCategories();
  }, []);


  useEffect(() => {
    if (carouselImages.length > 0) {
      const slideInterval = setInterval(goToNextSlide, 5000);
      return () => clearInterval(slideInterval);
    }
  }, [carouselImages.length]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowButtonText(false);
    }, 5000);

    return () => clearTimeout(timer);
  }, []);

  // Prevent body scroll when mobile filter is open
  useEffect(() => {
    if (isMobileFilterOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isMobileFilterOpen]);

  const categories = apiCategories.length > 0 ? apiCategories : defaultCategories;

  const handleCategoryChange = (event) => {
    const { value, checked } = event.target;
    if (checked) {
      setSelectedCategories((prev) => [...prev, value]);
    } else {
      setSelectedCategories((prev) => prev.filter((cat) => cat !== value));
    }
  };

  const handlePriceChange = (event) => {
    setPriceRange([0, parseInt(event.target.value)]);
  };



  const filteredProducts = useMemo(() => {
    let filtered = products.filter((product) => {
      // Search filter
      const matchesSearch = searchQuery === '' ||
        product.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
        (product.description && product.description.toLowerCase().includes(searchQuery.toLowerCase()));

      // Category filter
      const matchesCategory =
        selectedCategories.length === 0 ||
        (product.category && selectedCategories.includes(product.category));

      // Main category filter
      const matchesMainCategory =
        selectedMainCategory === '' ||
        (product.mainCategory && product.mainCategory === selectedMainCategory);

      // Sub category filter
      const matchesSubCategory =
        selectedSubCategory === '' ||
        (product.subCategory && product.subCategory === selectedSubCategory);

      // Price filter
      const matchesPrice =
        product.price >= minPrice &&
        product.price <= maxPrice;

      return matchesSearch && matchesCategory && matchesMainCategory && matchesSubCategory && matchesPrice;
    });

    // Sort products
    if (sortOption) {
      filtered = [...filtered].sort((a, b) => {
        switch (sortOption) {
          case 'low_to_high':
            return a.price - b.price;
          case 'high_to_low':
            return b.price - a.price;
          case 'a_z':
            return a.name.localeCompare(b.name);
          case 'z_a':
            return b.name.localeCompare(a.name);
          case 'newest':
            return new Date(b.createdAt || 0) - new Date(a.createdAt || 0);
          default:
            return 0;
        }
      });
    }

    return filtered;
  }, [products, selectedCategories, minPrice, maxPrice, searchQuery, sortOption, selectedMainCategory, selectedSubCategory]);



  // const filteredProducts = useMemo(() => {
  //   return products.filter((product) => {
  //     const matchesCategory =
  //       selectedCategories.length === 0 ||
  //       (product.category && selectedCategories.includes(product.category));
  //     const matchesPrice = product.price >= priceRange[0] && product.price <= priceRange[1];
  //     return matchesCategory && matchesPrice;
  //   });
  // }, [products, selectedCategories, priceRange]);

  const getWhatsAppLink = () => {
    return `https://wa.me/${whatsAppPhoneNumber}?text=${encodeURIComponent(whatsAppDefaultMessage)}`;
  };

  const toggleOptionsMenu = () => {
    setIsOptionsMenuOpen(prev => !prev);
    setIsChatPopupOpen(false);
  };

  const handleWhatsAppClick = () => {
    window.open(getWhatsAppLink(), '_blank');
    setIsOptionsMenuOpen(false);
  };

  const handleChatUIClick = () => {
    setIsChatPopupOpen(true);
    setIsOptionsMenuOpen(false);
  };

  // Filter Component (reusable for both desktop and mobile)
  const FilterContent = ({ isMobile = false }) => (
    <div className={`bg-white ${isMobile ? '' : 'border border-gray-300 rounded-lg'} overflow-hidden`}>
      {/* Filter Header */}
      <div className={`bg-[#F0F2F2] px-4 py-3 ${isMobile ? '' : 'border-b border-gray-300'} flex items-center justify-between`}>
        <h2 className="text-lg font-bold text-gray-900">Filters</h2>
        {isMobile && (
          <button
            onClick={() => setIsMobileFilterOpen(false)}
            className="text-gray-600 hover:text-gray-900 p-1"
          >
            <FaTimes className="text-xl" />
          </button>
        )}
      </div>

      {/* Filter Content */}
      <div className={`p-4 space-y-6 ${isMobile ? 'max-h-[calc(100vh-180px)]' : 'max-h-[calc(100vh-120px)]'} overflow-y-auto custom-scrollbar`}>

        {/* Search Filter */}
        <div className="pb-4 border-b border-gray-300">
          <h3 className="text-base font-bold text-gray-900 mb-3">Search</h3>
          <input
            type="search"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            placeholder="Search products..."
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#FF9900] focus:border-transparent text-sm"
          />
        </div>

        {/* Price Range Input */}
        <div className="pb-4 border-b border-gray-300">
          <h3 className="text-base font-bold text-gray-900 mb-3">Price Range</h3>
          <div className="flex gap-2 mb-3">
            <input
              type="number"
              value={minPrice}
              onChange={(e) => setMinPrice(Number(e.target.value))}
              placeholder="Min"
              className="w-1/2 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#FF9900] focus:border-transparent text-sm"
            />
            <input
              type="number"
              value={maxPrice}
              onChange={(e) => setMaxPrice(Number(e.target.value))}
              placeholder="Max"
              className="w-1/2 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#FF9900] focus:border-transparent text-sm"
            />
          </div>
          {/* Price Slider */}
          <input
            type="range"
            min="0"
            max="200000"
            value={priceRange[1]}
            onChange={(e) => {
              const value = parseInt(e.target.value);
              setPriceRange([0, value]);
              setMaxPrice(value);
            }}
            className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer"
            style={{
              background: `linear-gradient(to right, #FF9900 0%, #FF9900 ${(priceRange[1] / 200000) * 100}%, #E5E7EB ${(priceRange[1] / 200000) * 100}%, #E5E7EB 100%)`
            }}
          />
          <div className="mt-2 flex items-center justify-between text-xs text-gray-600">
            <span>৳{minPrice.toLocaleString()}</span>
            <span>৳{maxPrice.toLocaleString()}</span>
          </div>
        </div>

        {/* Main Category Filter */}
        <div className="pb-4 border-b border-gray-300">
          <h3 className="text-base font-bold text-gray-900 mb-3">Main Category</h3>
          <select
            value={selectedMainCategory}
            onChange={(e) => setSelectedMainCategory(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#FF9900] focus:border-transparent text-sm bg-white cursor-pointer"
          >
            <option value="">All main categories</option>
            <option value="Mens Fashion">Mens Fashion</option>
            <option value="Womens Fashion">Womens Fashion</option>
            <option value="Gadget & Electronics">Gadget & Electronics</option>
            <option value="Home Appliances">Home Appliances</option>
          </select>
        </div>

        {/* Sub Category Filter */}
        <div className="pb-4 border-b border-gray-300">
          <h3 className="text-base font-bold text-gray-900 mb-3">Sub Category</h3>
          <select
            value={selectedSubCategory}
            onChange={(e) => setSelectedSubCategory(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#FF9900] focus:border-transparent text-sm bg-white cursor-pointer"
          >
            <option value="">All sub categories</option>
            <option value="Shirts">Shirts</option>
            <option value="Pants">Pants</option>
            <option value="T-Shirt">T-Shirt</option>
            <option value="Tops Long">Tops Long</option>
            <option value="Ladies Plajo">Ladies Plajo</option>
            <option value="Phone">Phone</option>
            <option value="Headphones & Earphones">Headphones & Earphones</option>
            <option value="Laptop">Laptop</option>
            <option value="AC">AC</option>
            <option value="Electric Kettle">Electric Kettle</option>
          </select>
        </div>

        {/* Category Checkboxes */}
        <div className="pb-4 border-b border-gray-300">
          <h3 className="text-base font-bold text-gray-900 mb-3">Filter by Tag</h3>
          <div className="space-y-2">
            {categories.map((category) => (
              <label
                key={category}
                className="flex items-center gap-2 cursor-pointer hover:bg-gray-50 p-1.5 rounded transition-colors group"
              >
                <input
                  type="checkbox"
                  value={category}
                  checked={selectedCategories.includes(category)}
                  onChange={handleCategoryChange}
                  className="w-4 h-4 text-[#FF9900] bg-white border-gray-400 rounded focus:ring-[#FF9900] focus:ring-2 cursor-pointer"
                />
                <span className="text-sm text-gray-800 group-hover:text-[#C45500] transition-colors">
                  {category}
                </span>
              </label>
            ))}
          </div>
        </div>

        {/* Sort Filter */}
        <div className="pt-2">
          <h3 className="text-base font-bold text-gray-900 mb-3">Sort</h3>
          <select
            value={sortOption}
            onChange={(e) => setSortOption(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#FF9900] focus:border-transparent text-sm bg-white cursor-pointer"
          >
            <option value="">Relevance</option>
            <option value="low_to_high">Price: Low → High</option>
            <option value="high_to_low">Price: High → Low</option>
            <option value="a_z">Name: A → Z</option>
            <option value="z_a">Name: Z → A</option>
            <option value="newest">Newest</option>
          </select>
        </div>
      </div>

      {/* Filter Actions */}
      <div className={`p-4 border-t border-gray-300 bg-white ${isMobile ? 'sticky bottom-0' : ''}`}>
        <button
          onClick={handleApplyFilters}
          className="w-full bg-[#232F3E] hover:bg-[#131921] text-white font-semibold py-3 rounded-lg transition-colors duration-200 mb-2"
        >
          Apply Filters
        </button>
        <button
          onClick={handleClearFilters}
          className="w-full bg-white hover:bg-gray-100 text-gray-900 font-semibold py-3 rounded-lg border border-gray-300 transition-colors duration-200"
        >
          Clear All
        </button>
      </div>
    </div>
  );

  return (
    <div className="w-screen relative left-1/2 right-1/2 -ml-[50vw] -mr-[50vw] overflow-x-hidden">

      {/* Margin Spacer */}
      <div className="mt-4 md:mt-8 lg:mt-8"></div>
      {/* Carousel Section - Amazon style hero */}
      {carouselImages.length > 0 && (
        <div className="relative w-full mb-4 flex justify-center">
          <div className="flex flex-col md:flex-row gap-2 md:gap-4 px-4 md:px-6 max-w-[95vw] lg:max-w-[1400px] mx-auto">
            {/* Main Slider */}
            <div className="relative w-full h-[200px] sm:h-[250px] md:w-full lg:w-[950px] md:h-[616px] overflow-hidden bg-gradient-to-b from-gray-100 to-white rounded-lg md:flex-shrink-0">
              <div
                className="flex h-full transition-transform duration-500 ease-in-out"
                style={{ transform: `translateX(-${currentSlide * 100}%)` }}
              >
                {carouselImages.map((image, index) => (
                  <img
                    key={index}
                    src={image}
                    alt={`Slide ${index + 1}`}
                    className="w-full h-full object-cover flex-shrink-0"
                  />
                ))}
              </div>

              {/* Carousel indicators */}
              <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex gap-2">
                {carouselImages.map((_, index) => (
                  <button
                    key={index}
                    onClick={() => setCurrentSlide(index)}
                    className={`w-2 h-2 rounded-full transition-all duration-300 ${currentSlide === index ? 'bg-[#FF9900] w-6' : 'bg-gray-400 hover:bg-gray-500'
                      }`}
                    aria-label={`Go to slide ${index + 1}`}
                  />
                ))}
              </div>
            </div>

            {/* // Main carousel section এর মধ্যে এই অংশটা replace করুন */}

            {/* Thumbnail Images / Campaigns - Desktop: Right side vertical, Mobile: Bottom horizontal */}
            <div className="flex md:flex-col gap-2 md:gap-4 justify-start md:justify-start overflow-x-auto md:overflow-x-visible scrollbar-hide pb-2 md:pb-0">
              {upcomingCampaigns.length === 0 && cardBanners.length >= 2 && (
                // No campaigns - show 2 card banners
                <>
                  {cardBanners.slice(0, 2).map((banner, index) => (
                    <div
                      key={index}
                      onClick={() => setCurrentSlide(index)}
                      className="cursor-pointer rounded-md overflow-hidden transition-all duration-200 hover:opacity-80 flex-shrink-0 w-[45%] md:w-full lg:w-[380px] h-[90px] sm:h-[110px] md:h-[290px]"
                    >
                      <img
                        src={banner.imageUrl}
                        alt={`Card Banner ${banner.cardIndex}`}
                        className="w-full h-full object-cover bg-white"
                      />
                    </div>
                  ))}
                </>
              )}

              {upcomingCampaigns.length === 1 && cardBanners.length >= 1 && (
                // 1 campaign - show 1 campaign + 1 card banner
                <>
                  <div className="flex-shrink-0 w-[45%] md:w-full lg:w-[380px] h-[90px] sm:h-[110px] md:h-[290px] rounded-xl bg-[#f5f5f5] p-1.5 md:p-4">
                    <CampaignCard campaign={upcomingCampaigns[0]} />
                  </div>
                  <div
                    onClick={() => setCurrentSlide(0)}
                    className="cursor-pointer rounded-md overflow-hidden transition-all duration-200 hover:opacity-80 flex-shrink-0 w-[45%] md:w-full lg:w-[380px] h-[90px] sm:h-[110px] md:h-[290px]"
                  >
                    <img
                      src={cardBanners[0].imageUrl}
                      alt={`Card Banner ${cardBanners[0].cardIndex}`}
                      className="w-full h-full object-cover bg-white"
                    />
                  </div>
                </>
              )}

              {upcomingCampaigns.length === 2 && (
                // 2 campaigns - show 2 campaigns (mobile এ scroll হবে)
                <>
                  {upcomingCampaigns.slice(0, 2).map((campaign, index) => (
                    <div
                      key={campaign.id}
                      className="flex-shrink-0 w-[85%] md:w-full lg:w-[380px] h-[90px] sm:h-[110px] md:h-[290px] rounded-xl bg-[#f5f5f5] p-1.5 md:p-4"
                    >
                      <CampaignCard campaign={campaign} />
                    </div>
                  ))}
                </>
              )}

              {upcomingCampaigns.length >= 3 && (
                // 3+ campaigns - show with scroll (mobile এ horizontal scroll)
                <>
                  {upcomingCampaigns.map((campaign) => (
                    <div
                      key={campaign.id}
                      className="flex-shrink-0 w-[85%] md:w-full lg:w-[380px] h-[90px] sm:h-[110px] md:h-[290px] rounded-xl bg-[#f5f5f5] p-1.5 md:p-4"
                    >
                      <CampaignCard campaign={campaign} />
                    </div>
                  ))}
                </>
              )}
            </div>
          </div> {/* Carousel container বন্ধ */}
        </div>
      )}


      {/* Google Ad Style Banner */}
      {/* {adBanner && adBanner.active && (
        <div className="w-full px-4 md:px-6 mb-4">
          <div className="max-w-[1600px] mx-auto">
            <div className="relative w-full h-[80px] sm:h-[100px] md:h-[120px] overflow-hidden rounded-lg shadow-sm">
              <img
                src={adBanner.imageUrl}
                alt="Advertisement"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      )} */}



      <ProductFeaturesSection
        addToCart={addToCart}
        toggleFavorite={toggleFavorite}
        isFavorite={isFavorite}
        cartItems={cartItems}
      />




      {/* Featured Banner Images Section - Before Offer Section */}
      {cardBanners.length >= 4 && (
        <div className="w-full px-4 md:px-6 mt-8 mb-8">
          <div className="max-w-[1600px] mx-auto">
            <div className="flex flex-col md:flex-row gap-4 justify-center">
              {cardBanners.slice(2, 4).map((banner, index) => (
                <div
                  key={index}
                  className="cursor-pointer rounded-lg overflow-hidden transition-all duration-200 hover:opacity-90 hover:shadow-lg w-full md:w-[925px] h-[222px] md:h-[390px]"
                >
                  <img
                    src={banner.imageUrl}
                    alt={`Featured Banner ${banner.cardIndex}`}
                    className="w-full h-full object-cover bg-white"
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      )}






      {/* Main Content Container */}
      <div className="flex flex-col md:flex-row gap-4 px-4 md:px-6">

        {/* Desktop Filter Sidebar */}
        {/* <aside className="hidden md:block w-full md:w-[260px] flex-shrink-0 md:sticky md:top-4 h-fit">
          <FilterContent />
        </aside> */}

        {/* Products Section */}
        <main className="flex-1 min-w-0 max-w-[1600px] mx-auto">

          {/* ALL ITEMS Header */}
          <div className="mb-6 px-2 mt-6">
            <h2
              className="text-2xl md:text-3xl font-bold text-gray-900"
              style={{ fontFamily: "'Rajdhani', sans-serif" }}
            >
              All Items
            </h2>
            <div className="w-full h-[1px] bg-gray-300 mt-3"></div>
          </div>

          {filteredProducts.length === 0 ? (
            <div className="bg-white border border-gray-300 rounded-lg p-8 md:p-12 text-center">
              <div className="max-w-md mx-auto">
                <div className="text-6xl mb-4">🔍</div>
                <h3 className="text-xl font-semibold text-gray-900 mb-2">No Products Found</h3>
                <p className="text-gray-600 mb-4">
                  We couldn't find any products matching your filters.
                </p>
                <button
                  onClick={handleClearFilters}
                  className="inline-block bg-[#FFD814] hover:bg-[#F7CA00] text-gray-900 font-semibold px-6 py-2 rounded-lg transition-colors duration-200"
                >
                  Clear Filters
                </button>
              </div>
            </div>
          ) : (
            <>
              {/* Product Grid */}
              <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-3 md:gap-4 pb-6">
                {filteredProducts.map((product, index) => (
                  <div
                    key={product.id}
                    className="relative"
                    data-aos="fade-up"
                    data-aos-duration="800"
                    data-aos-delay={Math.min(index * 50, 300)}
                  >
                    {product.PCW === 0 && (
                      <div className="absolute top-0 right-0 bg-[#00A650] text-white text-xs font-bold px-2 py-1 md:px-3 md:py-1.5 rounded-bl-lg z-10 shadow-md">
                        Free Delivery
                      </div>
                    )}
                    <ProductCard
                      product={product}
                      addToCart={addToCart}
                      toggleFavorite={toggleFavorite}
                      isFavorite={isFavorite}
                      cartItems={cartItems}
                      navigate={navigate}
                    />
                  </div>
                ))}
              </div>
            </>
          )}
        </main>

      </div>


      <div className="w-full flex justify-center items-center py-8">

        <a href="/product"
          style={{
            fontFamily: "'Półtawski Nowy', serif",
            background: "linear-gradient(135deg, #CD0302 0%, #F88702 100%)",
            color: "#fff",
            padding: "14px 48px",
            fontSize: "1.125rem",
            fontWeight: "600",
            textDecoration: "none",
            display: "inline-block",
            clipPath: "polygon(12px 0%, 100% 0%, calc(100% - 12px) 100%, 0% 100%)",
            letterSpacing: "0.05em",
            boxShadow: "4px 4px 0px #4F7E17",
            transition: "background 0.3s, box-shadow 0.3s, transform 0.2s",
          }}
          onMouseEnter={e => {
            e.currentTarget.style.background = "linear-gradient(135deg, #F0C400 0%, #F88702 100%)";
            e.currentTarget.style.color = "#CD0302";
            e.currentTarget.style.boxShadow = "6px 6px 0px #4F7E17";
            e.currentTarget.style.transform = "translateY(-2px)";
          }}
          onMouseLeave={e => {
            e.currentTarget.style.background = "linear-gradient(135deg, #CD0302 0%, #F88702 100%)";
            e.currentTarget.style.color = "#fff";
            e.currentTarget.style.boxShadow = "4px 4px 0px #4F7E17";
            e.currentTarget.style.transform = "translateY(0)";
          }}
        >
          Load More
        </a>
      </div>


      {/* Offer Section */}
      {/* <OfferSection /> */}



      {/* <SocialMediaSection /> */}

      <FeaturesSection />



      {/* Floating Chat/WhatsApp/Messenger/Call Buttons */}
      <div className="fixed bottom-20 md:bottom-6 right-6 z-[1000] flex flex-col items-end gap-3">
        {/* Options Menu - Desktop: সবসময় দেখাবে, Mobile: click করে দেখাবে */}
        <div className={`flex flex-col gap-3 mb-2 animate-fade-in ${isOptionsMenuOpen ? 'flex md:flex' : 'hidden md:flex'
          }`}>
          {/* WhatsApp Button */}
          <button
            onClick={handleWhatsAppClick}
            className="flex items-center justify-center gap-2 bg-[#25D366] hover:bg-[#1DA851] text-white rounded-full w-14 h-14 shadow-lg transition-all duration-200 hover:scale-110 active:scale-95"
            title="WhatsApp"
          >
            <FaWhatsapp className="text-2xl" />
          </button>

          {/* Messenger Button */}
          <button
            onClick={handleMessengerClick}
            className="flex items-center justify-center gap-2 bg-[#0084FF] hover:bg-[#0073E6] text-white rounded-full w-14 h-14 shadow-lg transition-all duration-200 hover:scale-110 active:scale-95"
            title="Messenger"
          >
            <FontAwesomeIcon icon={faFacebookMessenger} className="text-2xl" />
          </button>

          {/* Call Button */}
          <button
            onClick={handleCallClick}
            className="flex items-center justify-center gap-2 bg-[#34B7F1] hover:bg-[#2AA3DD] text-white rounded-full w-14 h-14 shadow-lg transition-all duration-200 hover:scale-110 active:scale-95"
            title="Call Us"
          >
            <FaPhone className="text-xl" />
          </button>
        </div>

        {/* Button Text - Modern tooltip style */}
        {showButtonText && !isOptionsMenuOpen && (
          <div
            className={`bg-gradient-to-r from-[#FF9900] to-[#FFB84D] text-white px-3 py-1.5 rounded-lg text-xs font-medium whitespace-nowrap shadow-xl transition-all duration-300 md:hidden backdrop-blur-sm ${showButtonText ? 'opacity-100 translate-y-0 scale-100' : 'opacity-0 translate-y-2 scale-95'
              }`}
            style={{
              boxShadow: '0 4px 20px rgba(255, 153, 0, 0.3)',
            }}
          >
            <div className="flex items-center gap-1.5">
              <span className="animate-pulse text-sm">💬</span>
              <span>Need Help?</span>
            </div>
          </div>
        )}

        {/* Main Button - Modern Amazon style - Smaller for mobile */}
        <button
          onClick={toggleOptionsMenu}
          className={`md:hidden relative overflow-hidden rounded-xl w-12 h-12 flex items-center justify-center shadow-2xl transition-all duration-300 hover:scale-105 active:scale-95 ${isOptionsMenuOpen
            ? 'bg-gradient-to-br from-gray-700 to-gray-900 rotate-90'
            : 'bg-gradient-to-br from-[#FF9900] to-[#FFB84D]'
            }`}
          style={{
            boxShadow: isOptionsMenuOpen
              ? '0 8px 30px rgba(0, 0, 0, 0.3)'
              : '0 8px 30px rgba(255, 153, 0, 0.4)',
          }}
        >
          {/* Background pulse effect */}
          {!isOptionsMenuOpen && (
            <div className="absolute inset-0 bg-white opacity-0 group-hover:opacity-20 transition-opacity duration-300"></div>
          )}

          {/* Icon */}
          <div className={`text-white text-xl transition-all duration-300 ${isOptionsMenuOpen ? 'rotate-0' : 'rotate-0'
            }`}>
            {isOptionsMenuOpen ? (
              <FaTimes className="drop-shadow-lg" />
            ) : (
              <div className="relative">
                <FaComments className="drop-shadow-lg" />
                {/* Notification dot */}
                <span className="absolute -top-0.5 -right-0.5 w-2.5 h-2.5 bg-red-500 rounded-full border border-white animate-pulse"></span>
              </div>
            )}
          </div>

          {/* Ripple effect on click */}
          <span className="absolute inset-0 rounded-xl bg-white opacity-0 pointer-events-none transition-opacity duration-200 active:opacity-30"></span>
        </button>
      </div>
      <style jsx>{`
         @keyframes pulse {
            0%, 100% {
              transform: scale(1);
              opacity: 1;
            }
            50% {
              transform: scale(1.05);
              opacity: 0.8;
            }
          }
  
  .animate-fade-in {
    animation: fade-in 0.3s ease-out;
  }

  /* Custom scrollbar */
  .custom-scrollbar::-webkit-scrollbar {
    width: 6px;
  }
  
  .custom-scrollbar::-webkit-scrollbar-track {
    background: #f1f1f1;
  }
  
  .custom-scrollbar::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 3px;
  }
  
  .custom-scrollbar::-webkit-scrollbar-thumb:hover {
    background: #555;
  }

  /* Range input styling */
  input[type="range"]::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background: #FF9900;
    cursor: pointer;
    border: 2px solid white;
    box-shadow: 0 2px 4px rgba(0,0,0,0.2);
  }

  input[type="range"]::-moz-range-thumb {
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background: #FF9900;
    cursor: pointer;
    border: 2px solid white;
    box-shadow: 0 2px 4px rgba(0,0,0,0.2);
  }

  .hide-scrollbar {
    -ms-overflow-style: none;
    scrollbar-width: none;
  }
  
  .hide-scrollbar::-webkit-scrollbar {
    display: none;
  }

  .scrollbar-hide {
    -ms-overflow-style: none;
    scrollbar-width: none;
  }
  
  .scrollbar-hide::-webkit-scrollbar {
    display: none;
  }
`}</style>
    </div>
  );
};

export default ProductList;
